module.exports = __webpack_public_path__ + "img/p1.70257a60.png";